import React, { useState, useEffect } from "react";
import { fetchMaster } from "../../../utils/api";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TableSortLabel,
  Skeleton,
} from "@mui/material";
import styleClass from "./Employee.module.scss";
import moment from "moment";

const Employee = () => {
  const [employeeInfo, setEmployeeInfo] = useState([]);
  const [lastModifiedDateTime, setLastModifiedDateTime] = useState(" ");
  const [isLoading, setIsLoading] = useState(true);

  const initialFetch = async () => {
    const employeeInfoPromise = fetchMaster("/data-lake-report/get-latest-report", {
      reportType: "employee-list"
    });

    Promise.all([employeeInfoPromise])
      .then(([employeeInfoResponse]) => {
        setIsLoading(false);
        if (employeeInfoResponse.message === "SUCCESS") {
          setEmployeeInfo(employeeInfoResponse.data);
          setLastModifiedDateTime(employeeInfoResponse.lastModifiedDateTime)
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        setIsLoading(false);
        // Handle errors here
      });
    return;
  };

  useEffect(() => {
    const init = async () => {
      await initialFetch();
    };
    init();
  }, []);

  const tableColumns = [
    {
      title: "*Merchant ID",
      dataIndex: "Merchant ID",
      sorter: true,
      width: 120,
    },
    {
      title: "Merchant Legal Name",
      dataIndex: "Merchant Legal Name",
      width: 100,
    },
    {
      title: "Merchant DBA Name",
      dataIndex: "Merchant DBA Name",
      width: 100,
    },
    {
      title: "Employee ID",
      dataIndex: "Employee ID",
      width: 100,
    },
    {
      title: "Employee Login Name",
      dataIndex: "Employee Login Name",
      width: 150,
    },
    {
      title: "Employee Account Status",
      dataIndex: "Employee Account Status",
      width: 200,
    },
  ];

  const TableRowsLoader = ({ rowsNum, columns }) => {
    return [...Array(rowsNum)].map((row, index) => (
      <TableRow key={index}>
        {Object.keys(columns).map(() => {
          return (
            <TableCell component="th" scope="row" key={index}>
              <Skeleton animation="wave" variant="text" />
            </TableCell>
          )
        })}
      </TableRow>
    ));
  };

  const renderTableContent = (sortedData, columns) => {
    if (isLoading) {
      return (<TableRowsLoader rowsNum={10} columns={columns} />)
    } else {
      return (
        sortedData.map((row, index) => (
          <TableRow key={index}>
            {columns.map((column) => (
              <TableCell key={column.dataIndex}>
                {column.render
                  ? column.render(row[column.dataIndex])
                  : row[column.dataIndex]}
              </TableCell>
            ))}
          </TableRow>
        ))
      );
    }
  }

  const renderScrollableTable = (columns, data) => {
    const [sortConfig, setSortConfig] = useState({
      key: "merchantId",
      direction: "asc",
    });
    const handleSort = (key) => {
      const direction =
        sortConfig.key === key && sortConfig.direction === "asc"
          ? "desc"
          : "asc";
      setSortConfig({ key, direction });
    };
    const sortedData = data.sort((a, b) => {
      if (sortConfig.direction === "asc") {
        return parseInt(a[sortConfig.key]) >= parseInt(b[sortConfig.key])
          ? 1
          : -1;
      } else {
        return parseInt(a[sortConfig.key]) < parseInt(b[sortConfig.key])
          ? 1
          : -1;
      }
    });
    return (
      <TableContainer component={Paper}>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.dataIndex}
                  style={{ minWidth: column.width }}
                >
                  {column.sorter ? (
                    <TableSortLabel
                      active={sortConfig.key === column.dataIndex}
                      direction={
                        sortConfig.key === column.dataIndex
                          ? sortConfig.direction
                          : "asc"
                      }
                      onClick={() => handleSort(column.dataIndex)}
                      hideSortIcon={false}
                    >
                      {column.title}
                    </TableSortLabel>
                  ) : (
                    column.title
                  )}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {renderTableContent(sortedData, columns)}
          </TableBody>
        </Table>
      </TableContainer>
    );
  };

  return (
    <div style={{ padding: "24px" }}>
      <div className={styleClass.lastModifiedDateTime}>Last Updated: {moment(lastModifiedDateTime).format("YYYY-MM-DD HH:mm:ss")}</div>
      {renderScrollableTable(tableColumns, employeeInfo)}
    </div>
  );
};

export default Employee;
